import { defineStore, acceptHMRUpdate } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';

const rewardsStore = () => {
  const isLoading = ref<boolean>(false);
  const rewards = ref<RewardsFromApi>({ available: [], finisheds: [] });

  const rewrdsPagination = ref<{
    available: RewardsPagination;
    finisheds: RewardsPagination;
  }>({
    available: {
      current_page: 1,
      from: 0,
      last_page: 0,
      per_page: 0,
      to: 0,
      total: 0,
      filter: '',
    },
    finisheds: {
      current_page: 1,
      from: 0,
      last_page: 0,
      per_page: 0,
      to: 0,
      total: 0,
      filter: '',
    },
  });

  function $reset() {
    isLoading.value = false;
    rewards.value = { available: [], finisheds: [] };
  }

  return {
    $reset,
    isLoading,
    rewards,
    rewrdsPagination,
  };
};

export const useRewardsStore = defineStore(
  'rewards',
  rewardsStore,
  storeConfig,
);

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useRewardsStore, import.meta.hot));
}
